import React from 'react';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import update from 'react-addons-update';

class SMORoomEditDescriptionFragmentAttachFilesView extends React.Component {

  handleAddItem(e) {
    e.preventDefault();
    this.refs.inputFile.click();
  }
  
  handleDeleteItem(itemId, index, e) {
    e.preventDefault();
    if(window.confirm(I18n.t("dashboard.notice_000003"))){
      const newItems = update(this.props.items, {$splice: [[index, 1]]});
      $(document).trigger("SMRoomHandleDestroyHasManyAssociationItems", 
                          [{name: 'attach_files', value: newItems, id: itemId}]);
    }
  }
  
  itemDidAdd(e) {
    if(this.props.delegate && typeof this.props.delegate.fileFieldDidChangeValue === 'function'){
      this.props.delegate.fileFieldDidChangeValue(e);
    }
    e.currentTarget.value = null;
  }
  
  render() {
    const createItem = function(item, index, array) {
      if (item.id) {
        return(
          <p key={item.id} className={index == array.length - 1 ? 'mb10' : ''}>
            <i className="fa fa-paperclip"></i> {item.description}（{item.size_amount_text}）
            <a href="#" className="link-hover-border" onClick={this.handleDeleteItem.bind(this, item.id, index)}><i className="fa fa-times"></i> 削除する</a>
          </p>    
        );
      } else {
        return <p key={index}></p>; 
      }
    };
    
    return(
      <div className="form-box">
        <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
        {this.props.items.map(createItem, this)}
        </CSSTransitionGroup>
        <input type='file' ref='inputFile' name={'attach_files[]'} onChange={this.itemDidAdd.bind(this)} hidden />
        <p><a className="button button-gray pt10 pb10 w180" 
          onClick={this.handleAddItem.bind(this)}><i className="fa fa-plus"></i> ファイルを選択</a></p>
        <SMFormValidationMessage name='attach_files' errorText={SMFormatHelper.errorText('Attachment', 'file', this.props.errors)} />
      </div>
    );
  }
}

export default SMORoomEditDescriptionFragmentAttachFilesView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditDescriptionFragmentAttachFilesView.jsx